import React from 'react';

import {i18n} from '../utils';
import {CHECKOUT_TYPE_BUTTON, CHECKOUT_TYPE_QR} from '../constants';
import {Case, Switch} from './switch-case';
import {Button} from 'reactstrap';

i18n.initialize();

const ResultIcon = ({ result }) => {
  return (
    <Switch>
      <Case condition={result.response === "1" || result.response === "00"}>
        <img src={require('../assets/success.png')} alt="Success"/>
      </Case>
      <img src={require('../assets/denied.png')} alt="Denied"/>
    </Switch>
  )
}

const ResultTitle = ({ result }) => {
    i18n.changeLanguage(localStorage.getItem('productLanguage'));

    return (
    <Switch>
      <Case condition={result.response === "0"}>
        <h2>{ i18n.t('order_not_found') }</h2>
      </Case>
      <Case condition={result.response === "1" || result.response === "00"}>
        <h2>{ i18n.t('thanks_for_your_purchase') }</h2>
      </Case>
      <Case condition={result.response === "CI"}>
          <h2>{ i18n.t('ci_message') }</h2>
      </Case>
      <Case condition={!(result.orderid && result.orderid > 0)}>
          <h2>{ i18n.t('no_response') }</h2>
      </Case>
      <h2>{ i18n.t('transaction_denied') }</h2>
    </Switch>
  )
}

const ResultSubtitle = ({ result }) => {
    i18n.changeLanguage(localStorage.getItem('productLanguage'));

    return (
    <Switch>
      <Case condition={(result.response === "1" || result.response === "00") && result.transaction && result.transaction !== ''}>
        <h3>{ i18n.t('operation_number') }: {result.transaction}</h3>
      </Case>
        <Case condition={(result.response === "CI")}>
            {parseText(result.message)}
        </Case>
      <Case condition={!(result.orderid && result.orderid > 0)}>
        <h3>{ i18n.t('no_response_message') }</h3>
      </Case>
    </Switch>
  )
}

const ResultBody = ({ result}) => {
  i18n.changeLanguage(localStorage.getItem('productLanguage'));

  return (
    <Switch>
      <Case condition={result.response === "1" || result.response === "00"}>
        <span>{ i18n.t('contact_merchant') }</span>
        { result.merchantUrl && (
          <a href={result.merchantUrl}>
            <Button color="link">{ i18n.t('go_purchase_website') }</Button>
          </a>
        )}
      </Case>
      <Case condition={
          (result.token || localStorage.getItem('referer'))
          && (result.orderid && result.orderid > 0)
          && result.type !== CHECKOUT_TYPE_QR}>
        <Button
          color="primary"
          href={
            result.isButton
              ? "/" + result.token
              : localStorage.getItem('referer')
          }
        >
          { i18n.t('try_again') }
        </Button>
      </Case>
        <Case condition={result.type === CHECKOUT_TYPE_QR}>
            <h2>{ i18n.t('new_qr') }</h2>
        </Case>
    </Switch>
  )
}

function parseText(text) {
    let newText = '"' + text + '"';
    let decoded = decodeURIComponent(JSON.parse(newText));

    if(new RegExp("([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?").test(decoded)) {
        let matches = decoded.match(/\bhttps?:\/\/\S+/gi);
        decoded = decoded.replace(matches[0], "");
        return (
            <h3> { decoded } <a target="_blank" href={ matches[0] }>Click Aquí</a> (<a target="_blank" href={ matches[0] }>{ matches[0] }</a>)</h3>
        )
    }
    return (
        <h3> {decoded} </h3>
    )
}

const ResultMessage = ({ result }) => {
    return (
    <div className="full-message result-message">
      <div className="result-header">
        <ResultIcon result={result}/>
        <ResultTitle result={result}/>
        <ResultSubtitle result={result}/>
      </div>
      <div className="result-body">
        < ResultBody
            result={result}
        />
      </div>
    </div>
  )
}

export default ResultMessage



// WEBPACK FOOTER //
// ./client/components/ResultMessage.js